import React, { FC, useEffect } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { documentService, windowService } from '../../utils/window.utils';
import Heading from '../@shared/heading';
import BrochureCard from './components/brochureCard';
import { ProductDownloadBrochureModel } from './models/downloadBrochures.model';
import { TDownloadBrochuresProps } from './types/downloadBrochures.types';
import '../../styles/@shared/downloadBrochures/styles.scss';

const ProductDownloadBrochures: FC<TDownloadBrochuresProps & { wrapperClassName?: string }> = (props) => {
  const model = new ProductDownloadBrochureModel(props);

  useEffect(() => {
    setTimeout(() => {
      const shareScript = 'https://static.addtoany.com/menu/page.js';
      const addthisScript = documentService()?.createElement?.('script');
      addthisScript.setAttribute('src', shareScript);
      const shareContentScript = documentService()?.querySelector?.(`[src="${shareScript}"]`);
      if (documentService()?.body && !shareContentScript) documentService()?.body?.appendChild?.(addthisScript);
      else windowService()?.a2a?.init_all?.();
    });
  }, [model.currentPageUrl]);

  return (
    <section>
      <div className={`download-brochure-container download-brochure-container__min-width-none ${props.wrapperClassName || ''}`}>
        <div className="download-brochure-container__label-container">
          <Heading
            eyebrow={model.eyebrow}
            title={model.title}
            subtitle={model.subHeading}
          />
        </div>
        <div className="download-brochure-container__card-container">
          {model?.brochureCards.map((card) => (
            <BrochureCard
              {...card}
              key={card.id}
              shareIcon={model.shareIcon}
              viewIcon={model.viewIcon}
              downloadIcon={model.downloadIcon}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default withSitecoreContext()(ProductDownloadBrochures);
